// src/schemas/user-profile.ts
import { z } from "zod";

export const userProfileSchema = z.object({
  id: z.number(),
  user: z.number(),
  phone_number: z.string().nullable().optional(),
  created_at: z.string(), // ISO datetime
  updated_at: z.string(), // ISO datetime
  is_email_aggregator_enabled: z.boolean(),
  daily_page_limit: z.number(),
  has_completed_onboarding: z.boolean(),
});

export type UserProfile = z.infer<typeof userProfileSchema>;
